<template>
  <div class="CadView-container">
    <el-row class="tcf-row">
      <div class="card">
        <div class="card-body">
          <div class="card-title" v-loading="loading">
            {{fileData.dName}}.{{fileData.dType}}
            <el-button type="primary" size="small" style="float: right" icon="el-icon-download" @click="downCad">下载图纸</el-button>
          </div>
          <div class="card-content">
            <div class="pdf-main">
<!--                  <object ref="pdfcad" data="/222.pdf#scrollbars=0&toolbar=0&statusbar=0" type="application/pdf" @mousewheel="mousewheelFn"   :style="'width: 100%;height:'+divHeight+'px;'">-->
<!--                    <param name="bgColor" value="#ffffff">-->
<!--                    您的浏览器暂不支持预览CAD，请使用谷歌浏览器-->
<!--                  </object>-->
<!--              <object ref="WebCAD" data="/1.swf" :style="'width: 100%;height:'+divHeight+'px;'" type="application/x-shockwave-flash" >-->
<!--                <param name="movie" value="/1.swf">-->
<!--                <param name="quality" value="high">-->
<!--                <param name="bgColor" value="#000000"> &lt;!&ndash;设置flash的背景色&ndash;&gt;-->
<!--                <param name="allowFullScreen" value="true">-->
<!--                <param name="play" value="true">-->
<!--                <param name="loop" value="true">-->
<!--                <param name="wmode" value="window">-->
<!--                <param name="wmode" value="Opaque">-->
<!--                <param name="scale" value="showall">-->
<!--                <param name="menu" value="true">-->
<!--                <param name="devicefont" value="false">-->
<!--                <param name="salign" value="">-->
<!--              </object>-->
            </div>
          </div>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getFileInfoByCAD } from '@/api/work'
import { getFileInfo } from '@/api/pub'

export default {
  name: 'CadView',
  computed: {
    user: getUser
  },
  data() {
    return {
      divHeight: 0,
      fileid: '',
      fileData: {},
      loading: false
    }
  },
  created() {
    this.tempRoute = Object.assign({}, this.$route)
    this.fileid = this.$route.params && this.$route.params.id
    this.loading = true
    this.divHeight = document.body.offsetHeight - 235
    getFileInfoByCAD({ fileid: this.fileid }).then(response => {
      this.fileData = response.data
      let pageTitle = `${response.data.dName}.${response.data.dType}`
      if (pageTitle.length > 10) {
        pageTitle = pageTitle.substring(0, 10) + '...'
      }
      document.title = pageTitle
      const route = Object.assign({}, this.tempRoute, { title: pageTitle })
      this.$store.dispatch('tagsView/updateVisitedView', route)
      this.loading = false
    }).catch(() => {
      this.loading = false
    })
  },
  methods: {
    mousewheelFn(ev) {
      let up = true
      console.info(ev.wheelDelta)
      if (ev.wheelDelta) {
        up = ev.wheelDelta > 0 ? true : false
      } else {
        up = ev.detail < 0 ? true : false
      }
      if (up) {
        // this.$refs.WebCAD.Zoom(80)
        this.$refs.pdfcad.style.width = 200
      } else {
        // this.$refs.WebCAD.Zoom(120)
        this.$refs.pdfcad.style.width = 100
      }
    },
    downCad() {
      getFileInfo({ fileid: this.fileid }).then(response => {
        const a = document.createElement('a')
        // a.download = response.data.dName + '.' + response.data.dType
        a.href = response.data.copyPath
        a.target = '_blank'
        a.click()
        const h = this.$createElement
        this.$msgbox({
          title: '下载提示',
          message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
            h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
            h('a',
              { attrs: {
                  href: response.data.copyPath,
                  target: '_blank',
                  download: `${response.data.dName}.${response.data.dType}`,
                  style: 'color: #409EFF;text-decoration:underline;'
                }}, `点击这里`),
            h('span', null, `重新下载。`)
          ]),
          showCancelButton: false,
          confirmButtonText: '关闭',
          beforeClose: (action, instance, done) => {
            done()
          }
        }).then(action => {
        })
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.CadView-container{
  .tcf-row{
    .card{
      .card-body{
        .card-content{
          .pdf-main{
            width: 100%;
            position: relative;
            border:1px solid #F2F6FC;
            overflow: hidden;
          }
        }
      }
    }
  }
}
</style>
